import React, { useEffect, useState } from 'react';
import Row from "@Containers/components/Row";
import IconUserOutline from "@Icons/user/IconUserOutline"; 
import IconHandLuggage from "@Icons/searchRes/amenities/IconHandLuggage";
import { Colors } from "@Styles/Colors.style";
import Button from '@/components/buttons/Button';
import IconChevronDouble from '@/components/icons/chevrons/IconChevronDouble';
import useIsTablet from '@/hooks/selector/useIsTablet';
import useIsMobile from '@/hooks/selector/useIsMobile';
import useIsSmallDesktop from '@/hooks/selector/useIsSmallDesktop';
import Translation from '@/features/translation/components/Translation';
import Column from '@/features/containers/components/Column';
import useCurrency from '@/features/currency/hooks/useCurrency';

interface VehicleSnippetFooterProps {
    maxNumberOfPassengers: number;
    price?: number;
}

const VehicleSnippetFooter: React.FC<VehicleSnippetFooterProps> = ({ maxNumberOfPassengers, price }) => {
    const isTablet = useIsTablet();
    const isMobile = useIsMobile();
    const selectedCurrency = useCurrency()
    const isSmallDesktop = useIsSmallDesktop();
    const [currency, setCurrency] = useState(selectedCurrency);

    const ctaTranslationKey = price ? 'transfers_banner.cta.native' : 'transfers_banner.cta.mozio';

    useEffect(() => {
        setCurrency(selectedCurrency)
    }, [])


    return (
        <Row
            center={price ? false : true}
            className={price ? "gb--vehicle-card__footer" : ""}
        >
            <Column 
                style={{ flex: 1 }}
                reverse={isTablet || isMobile || isSmallDesktop}
            >
                {price && (
                    <span className="gb--vehicle-card__price">
                        {price}
                        {currency.sign}
                    </span>
                )}
                <Row gap>
                    <Row center className="gb--vehicle-card__info">
                        <IconUserOutline width={18} height={18}/>
                        {maxNumberOfPassengers}
                    </Row>
                    <Row center className="gb--vehicle-card__info">
                        <IconHandLuggage width={18} height={18}/>
                        {maxNumberOfPassengers}
                    </Row>
                </Row>
            </Column>
            <Column>
                {!isTablet && !isMobile && !isSmallDesktop ? (
                    <Button
                        className="secondary"
                        onClick={() => {}}
                    >
                        <Translation translationKey={ctaTranslationKey} />
                    </Button>
                ) : (
                    <IconChevronDouble
                        fill={Colors.neutralDarkestColor}
                        className="gb--vehicle-card__cta"
                        width="35"
                        height="35"
                    />
                )}
            </Column>
        </Row>
    );
};

export default VehicleSnippetFooter;
